import { Draft } from '@reduxjs/toolkit';

import { ITreeTradeData } from '../../initialState';

function getTreeTradeFailure(draft: Draft<ITreeTradeData>) {
  draft.getTreeTrade.config.isLoading = false;
}

export default getTreeTradeFailure;
